import { InstrumentType, InstrumentDefinition, TuningDefinition } from '../types';

export const UKULELE_STANDARD_TUNING: TuningDefinition = {
  id: 'ukulele-standard',
  label: 'Standard (GCEA)',
  pitches: [
    { note: 'A', octave: 4 },
    { note: 'E', octave: 4 },
    { note: 'C', octave: 4 },
    { note: 'G', octave: 4 },
  ],
};

export const UKULELE_BARITONE_TUNING: TuningDefinition = {
  id: 'ukulele-baritone',
  label: 'Baritone (DGBE)',
  pitches: [
    { note: 'E', octave: 4 },
    { note: 'B', octave: 3 },
    { note: 'G', octave: 3 },
    { note: 'D', octave: 3 },
  ],
};

export const UKULELE_DEFINITION: InstrumentDefinition = {
  type: InstrumentType.Ukulele,
  name: 'Ukulele',
  defaultNumFrets: 12,
  defaultTunings: [UKULELE_STANDARD_TUNING, UKULELE_BARITONE_TUNING],
};
